import { render, staticRenderFns } from "./ModalErrorPermission.vue?vue&type=template&id=4735a689"
import script from "./ModalErrorPermission.vue?vue&type=script&lang=js"
export * from "./ModalErrorPermission.vue?vue&type=script&lang=js"
import style0 from "./ModalErrorPermission.vue?vue&type=style&index=0&id=4735a689&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports